module.exports = __webpack_public_path__ + "0236b293aef3a242e53284d28bfaeada.ttf";